/**
 * Callout Card Component
 * 
 * Used for TL;DR sections and other highlighted content.
 * Based on the Terms/Privacy page TL;DR design.
 */

import type { ReactNode } from 'react';

interface CalloutCardProps {
  title?: string;
  children: ReactNode;
  variant?: 'default' | 'info' | 'warning';
}

export default function CalloutCard({ title = 'TL;DR', children, variant = 'default' }: CalloutCardProps) {
  const variantStyles = {
    default: 'bg-oro-surface border-oro-border',
    info: 'bg-oro-info/10 border-oro-info/30',
    warning: 'bg-oro-warning/10 border-oro-warning/30',
  }[variant];

  return (
    <div className={`mb-8 p-6 rounded-xl border ${variantStyles}`}>
      {title && (
        <h2 className="text-xl font-bold text-text-primary mb-4">
          {title}
        </h2>
      )}
      <div className="space-y-4 text-text-secondary">
        {children}
      </div>
    </div>
  );
}